import { envNames } from './envNames'

/**
 * @function isEnvIn
 * @category Config
 * @description Determines if process.env.NODE_ENV belongs to one of the options. Use with a negation exclamation mark (!) to obtain the boolean which excludes certain values instead of including them.
 * @param {string[]} selectedEnvironments - The values of process.env.NODE_ENV to check for. They should come from values of the object envNames (see above).
 */
export const isEnvIn = (...selectedEnvironments) => selectedEnvironments.includes(process.env.NODE_ENV)

/**
 * @function isDeployed
 * @category Config
 * @description Determines if process.env.NODE_ENV belongs to one of the options. Use with a negation exclamation mark (!) to obtain the boolean which excludes certain values instead of including them.
 * @param {string[]} options - The values of process.env.NODE_ENV to check for. They should come from values of the object envNames (see above).
 */
export const isDeployed = !isEnvIn(envNames.DEV, envNames.TEST)

/**
 * @function perEnv
 * @category Config
 * @description Returns a value that is specified as a function of the value of process.env.NODE_ENV. If the return value for the given value of process.env.NODE_ENV is not specified, it returns the value corresponding to the 'default' key. If that one is not specified either, the undefined value is returned.
 * @param {{[key: envNames]: any}} values - An object whose keys are values taken by process.env.NODE_ENV and whose values can be any value that has to be environment-specific.
 */
export const perEnv = values => values[process.env.NODE_ENV || 'default']
